import { render, staticRenderFns } from "./safemanege.vue?vue&type=template&id=969340e4&scoped=true&"
import script from "./safemanege.vue?vue&type=script&lang=js&"
export * from "./safemanege.vue?vue&type=script&lang=js&"
import style0 from "./safemanege.vue?vue&type=style&index=0&id=969340e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "969340e4",
  null
  
)

export default component.exports